import { useState, useCallback } from "react";
import { ApiCall, GetApiCall } from "../helper/axios";
import { formatPrice, getUserId, getUserToken } from "../helper/commonFunction";
import { useSelector, useDispatch } from "react-redux";
import { setWalletBalance } from "../redux/slice/userSlice";
import { getActiveCode, getActiveRate } from "../helper/currencyState";

const mock = false;

export const useWallet = () => {
  const userToken = getUserToken();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const { agentActiveCurrency } = useSelector((state) => state.userData);


  const generateNonceForTranscationFn = async (transcationType = 'wallet', type = 'debit') => {
    let nonceToken = '';
    const nonceData = await GetApiCall('GET', `wp-json/dahr/v1/generate-nonce?userToken=${userToken}&transaction_type=${type}&type=${transcationType}`, {}, 'wordpress');
    if (nonceData?.status === 200) {
      nonceToken = nonceData?.data?.nonce;
    }
    return nonceToken;
  }

  const getBalance = useCallback(async () => {
    try {
      if (mock) {
        return 1000000;
      }
      let balance;
      setLoading(true);
      setError(null);
      const walletBalanceData = await GetApiCall(
        "GET",
        `wp-json/dahr/v1/user-wallet-balance?userToken=${userToken}&activeUserCurrency=${agentActiveCurrency}&display_currency=${getActiveCode()}&conversion_rate=${getActiveRate()}`,
        {},
        "wordpress"
      );
      if (walletBalanceData?.status === 200) {
        balance = walletBalanceData?.data?.wallet_balance;
        dispatch(setWalletBalance(balance));
      }
      return balance;
    } catch (error) {
      setError(error?.message);
    } finally {
      setLoading(false);
    }
  }, [userToken, agentActiveCurrency, dispatch]);

  const debit = useCallback(async (amount, message, payment_mode = "wallet") => {
    if (mock) {
      return {
        status: 200,
        data: {
          success: true,
          transaction_id: 1,
        },
      };
    }
    let nonceToken = await generateNonceForTranscationFn('wallet','debit');
    const deductBalanceFromWallet = await ApiCall(
      "POST",
      `wp-json/dahr/v1/wallet-transaction`,
      {
        userToken: userToken,
        activeUserCurrency: agentActiveCurrency,
        display_currency: getActiveCode(),
        conversion_rate: getActiveRate(),
        transaction_type: "debit",
        payment_mode,
        amount:parseFloat(amount) || 0,
        transaction_comment: `${message}`,
        nonce : nonceToken,
      },
      {},
      "wordpress"
    );

    return deductBalanceFromWallet;
  }, [userToken, agentActiveCurrency, getBalance]);

  const credit = useCallback(async (amount, message, payment_mode = "wallet",transactionId='') => {
    if (mock) {
      return {
        status: 200,
        data: {
          success: true,
          transaction_id: 1,
        },
      };
    }
    let nonceToken = await generateNonceForTranscationFn(payment_mode,'credit');
    let payload = {
      userToken: userToken,
      activeUserCurrency: agentActiveCurrency,
      display_currency: getActiveCode(),
      conversion_rate: getActiveRate(),
      transaction_type: "credit",
      payment_mode,
      amount:parseFloat(amount) || 0,
      transaction_comment: `${message}`,
      nonce : nonceToken,
    };
    if(transactionId){
      payload.transactionId = transactionId;
    }
    const deductBalanceFromWallet = await ApiCall(
      "POST",
      `wp-json/dahr/v1/wallet-transaction`,
        payload,
      {},
      "wordpress"
    );

    return deductBalanceFromWallet;
  }, [userToken, agentActiveCurrency, getBalance]);

  const refreshWalletBalance = useCallback(async () => {
    await getBalance();
  }, [getBalance]);

  return {
    loading,
    error,
    debit,
    credit,
    getBalance,
    refreshWalletBalance,
  };
};
